const currencies = [
  {
    code: 'afn',
    name: 'Afghani',
    symbol: 'Af',
  },
  {
    code: 'eur',
    name: 'Euro',
    symbol: '€',
  },
  {
    code: 'all',
    name: 'Lek',
    symbol: 'Lek',
  },
  {
    code: 'dzd',
    name: 'Algerian Dinar',
    symbol: 'دج',
  },
  {
    code: 'usd',
    name: 'US Dollar',
    symbol: '$',
  },
  {
    code: 'cad',
    name: 'Canadian Dollar',
    symbol: 'CA$',
  },
  {
    code: 'aed',
    name: 'United Arab Emirates Dirham',
    symbol: 'AED',
  },
  {
    code: 'amd',
    name: 'Armenian Dram',
    symbol: 'AMD',
  },
  {
    code: 'ars',
    name: 'Argentine Peso',
    symbol: 'AR$',
  },
  {
    code: 'aud',
    name: 'Australian Dollar',
    symbol: 'AU$',
  },
  {
    code: 'azn',
    name: 'Azerbaijani Manat',
    symbol: 'man.',
  },
  {
    code: 'bam',
    name: 'Bosnia-Herzegovina Convertible Mark',
    symbol: 'KM',
  },
  {
    code: 'bdt',
    name: 'Bangladeshi Taka',
    symbol: 'Tk',
  },
  {
    code: 'bgn',
    name: 'Bulgarian Lev',
    symbol: 'BGN',
  },
  {
    code: 'bhd',
    name: 'Bahraini Dinar',
    symbol: 'BD',
  },
  {
    code: 'bif',
    name: 'Burundian Franc',
    symbol: 'FBu',
  },
  {
    code: 'bnd',
    name: 'Brunei Dollar',
    symbol: 'BN$',
  },
  {
    code: 'bob',
    name: 'Bolivian Boliviano',
    symbol: 'Bs',
  },
  {
    code: 'brl',
    name: 'Brazilian Real',
    symbol: 'R$',
  },
  {
    code: 'bwp',
    name: 'Botswanan Pula',
    symbol: 'BWP',
  },
  {
    code: 'byn',
    name: 'Belarusian Ruble',
    symbol: 'Br',
  },
  {
    code: 'bzd',
    name: 'Belize Dollar',
    symbol: 'BZ$',
  },
  {
    code: 'cdf',
    name: 'Congolese Franc',
    symbol: 'CDF',
  },
  {
    code: 'chf',
    name: 'Swiss Franc',
    symbol: 'CHF',
  },
  {
    code: 'clp',
    name: 'Chilean Peso',
    symbol: 'CL$',
  },
  {
    code: 'cny',
    name: 'Chinese Yuan',
    symbol: 'CN¥',
  },
  {
    code: 'cop',
    name: 'Colombian Peso',
    symbol: 'CO$',
  },
  {
    code: 'crc',
    name: 'Costa Rican Colón',
    symbol: '₡',
  },
  {
    code: 'cve',
    name: 'Cape Verdean Escudo',
    symbol: 'CV$',
  },
  {
    code: 'czk',
    name: 'Czech Republic Koruna',
    symbol: 'Kč',
  },
  {
    code: 'djf',
    name: 'Djiboutian Franc',
    symbol: 'Fdj',
  },
  {
    code: 'dkk',
    name: 'Danish Krone',
    symbol: 'Dkr',
  },
  {
    code: 'dop',
    name: 'Dominican Peso',
    symbol: 'RD$',
  },
  {
    code: 'dzd',
    name: 'Algerian Dinar',
    symbol: 'DA',
  },
  {
    code: 'eek',
    name: 'Estonian Kroon',
    symbol: 'Ekr',
  },
  {
    code: 'egp',
    name: 'Egyptian Pound',
    symbol: 'EGP',
  },
  {
    code: 'ern',
    name: 'Eritrean Nakfa',
    symbol: 'Nfk',
  },
  {
    code: 'etb',
    name: 'Ethiopian Birr',
    symbol: 'Br',
  },
  {
    code: 'gbp',
    name: 'British Pound Sterling',
    symbol: '£',
  },
  {
    code: 'gel',
    name: 'Georgian Lari',
    symbol: 'GEL',
  },
  {
    code: 'ghs',
    name: 'Ghanaian Cedi',
    symbol: 'GH₵',
  },
  {
    code: 'gnf',
    name: 'Guinean Franc',
    symbol: 'FG',
  },
  {
    code: 'gtq',
    name: 'Guatemalan Quetzal',
    symbol: 'GTQ',
  },
  {
    code: 'hkd',
    name: 'Hong Kong Dollar',
    symbol: 'HK$',
  },
  {
    code: 'hnl',
    name: 'Honduran Lempira',
    symbol: 'HNL',
  },
  {
    code: 'hrk',
    name: 'Croatian Kuna',
    symbol: 'kn',
  },
  {
    code: 'huf',
    name: 'Hungarian Forint',
    symbol: 'Ft',
  },
  {
    code: 'idr',
    name: 'Indonesian Rupiah',
    symbol: 'Rp',
  },
  {
    code: 'ils',
    name: 'Israeli New Sheqel',
    symbol: '₪',
  },
  {
    code: 'inr',
    name: 'Indian Rupee',
    symbol: 'Rs',
  },
  {
    code: 'iqd',
    name: 'Iraqi Dinar',
    symbol: 'IQD',
  },
  {
    code: 'irr',
    name: 'Iranian Rial',
    symbol: 'IRR',
  },
  {
    code: 'isk',
    name: 'Icelandic Króna',
    symbol: 'Ikr',
  },
  {
    code: 'jmd',
    name: 'Jamaican Dollar',
    symbol: 'J$',
  },
  {
    code: 'jpy',
    name: 'Japanese Yen',
    symbol: '¥',
  },
  {
    code: 'kes',
    name: 'Kenyan Shilling',
    symbol: 'Ksh',
  },
  {
    code: 'khr',
    name: 'Cambodian Riel',
    symbol: 'KHR',
  },
  {
    code: 'kmf',
    name: 'Comorian Franc',
    symbol: 'CF',
  },
  {
    code: 'krw',
    name: 'South Korean Won',
    symbol: '₩',
  },
  {
    code: 'kwd',
    name: 'Kuwaiti Dinar',
    symbol: 'KD',
  },
  {
    code: 'kzt',
    name: 'Kazakhstani Tenge',
    symbol: 'KZT',
  },
  {
    code: 'lbp',
    name: 'Lebanese Pound',
    symbol: 'L.L.',
  },
  {
    code: 'lkr',
    name: 'Sri Lankan Rupee',
    symbol: 'SLRs',
  },
  {
    code: 'ltl',
    name: 'Lithuanian Litas',
    symbol: 'Lt',
  },
  {
    code: 'lvl',
    name: 'Latvian Lats',
    symbol: 'Ls',
  },
  {
    code: 'lyd',
    name: 'Libyan Dinar',
    symbol: 'LD',
  },
  {
    code: 'mad',
    name: 'Moroccan Dirham',
    symbol: 'MAD',
  },
  {
    code: 'mdl',
    name: 'Moldovan Leu',
    symbol: 'MDL',
  },
  {
    code: 'mga',
    name: 'Malagasy Ariary',
    symbol: 'MGA',
  },
  {
    code: 'mkd',
    name: 'Macedonian Denar',
    symbol: 'MKD',
  },
  {
    code: 'mmk',
    name: 'Myanma Kyat',
    symbol: 'MMK',
  },
  {
    code: 'mop',
    name: 'Macanese Pataca',
    symbol: 'MOP$',
  },
  {
    code: 'mur',
    name: 'Mauritian Rupee',
    symbol: 'MURs',
  },
  {
    code: 'mxn',
    name: 'Mexican Peso',
    symbol: 'MX$',
  },
  {
    code: 'myr',
    name: 'Malaysian Ringgit',
    symbol: 'RM',
  },
  {
    code: 'mzn',
    name: 'Mozambican Metical',
    symbol: 'MTn',
  },
  {
    code: 'nad',
    name: 'Namibian Dollar',
    symbol: 'N$',
  },
  {
    code: 'ngn',
    name: 'Nigerian Naira',
    symbol: '₦',
  },
  {
    code: 'nio',
    name: 'Nicaraguan Córdoba',
    symbol: 'C$',
  },
  {
    code: 'nok',
    name: 'Norwegian Krone',
    symbol: 'Nkr',
  },
  {
    code: 'npr',
    name: 'Nepalese Rupee',
    symbol: 'NPRs',
  },
  {
    code: 'nzd',
    name: 'New Zealand Dollar',
    symbol: 'NZ$',
  },
  {
    code: 'omr',
    name: 'Omani Rial',
    symbol: 'OMR',
  },
  {
    code: 'pab',
    name: 'Omani Rial',
    symbol: 'B/.',
  },
  {
    code: 'pen',
    name: 'Peruvian Nuevo Sol',
    symbol: 'S/.',
  },
  {
    code: 'php',
    name: 'Philippine Peso',
    symbol: '₱',
  },
  {
    code: 'pkr',
    name: 'Pakistani Rupee',
    symbol: 'PKRs',
  },
  {
    code: 'pln',
    name: 'Polish Zloty',
    symbol: 'zł',
  },
  {
    code: 'pyg',
    name: 'Paraguayan Guarani',
    symbol: '₲',
  },
  {
    code: 'qar',
    name: 'Qatari Rial',
    symbol: 'QR',
  },
  {
    code: 'ron',
    name: 'Romanian Leu',
    symbol: 'RON',
  },
  {
    code: 'rsd',
    name: 'Serbian Dinar',
    symbol: 'din.',
  },
  {
    code: 'rub',
    name: 'Russian Ruble',
    symbol: 'RUB',
  },
  {
    code: 'rwf',
    name: 'Rwandan Franc',
    symbol: 'RWF',
  },
  {
    code: 'sar',
    name: 'Saudi Riyal',
    symbol: 'SR',
  },
  {
    code: 'sdg',
    name: 'Sudanese Pound',
    symbol: 'SDG',
  },
  {
    code: 'sek',
    name: 'Swedish Krona',
    symbol: 'Skr',
  },
  {
    code: 'sgd',
    name: 'Singapore Dollar',
    symbol: 'S$',
  },
  {
    code: 'sos',
    name: 'Somali Shilling',
    symbol: 'Ssh',
  },
  {
    code: 'syp',
    name: 'Syrian Pound',
    symbol: 'SY£',
  },
  {
    code: 'thb',
    name: 'Thai Baht',
    symbol: '฿',
  },
  {
    code: 'tnd',
    name: 'Tunisian Dinar',
    symbol: 'DT',
  },
  {
    code: 'top',
    name: 'Tongan Paʻanga',
    symbol: 'T$',
  },
  {
    code: 'try',
    name: 'Turkish Lira',
    symbol: 'TL',
  },
  {
    code: 'ttd',
    name: 'Trinidad and Tobago Dollar',
    symbol: 'TT$',
  },
  {
    code: 'twd',
    name: 'New Taiwan Dollar',
    symbol: 'NT$',
  },
  {
    code: 'tzs',
    name: 'Tanzanian Shilling',
    symbol: 'TSh',
  },
  {
    code: 'uah',
    name: 'Ukrainian Hryvnia',
    symbol: '₴',
  },

  {
    code: 'ugx',
    name: 'Ugandan Shilling',
    symbol: 'USh',
  },
  {
    code: 'uyu',
    name: 'Uruguayan Peso',
    symbol: '$U',
  },
  {
    code: 'uzs',
    name: 'Uzbekistan Som',
    symbol: 'UZS',
  },
  {
    code: 'vef',
    name: 'Venezuelan Bolívar',
    symbol: 'Bs.F.',
  },
  {
    code: 'vnd',
    name: 'Vietnamese Dong',
    symbol: '₫',
  },
  {
    code: 'xaf',
    name: 'CFA Franc BEAC',
    symbol: 'FCFA',
  },
  {
    code: 'xcd',
    name: 'East Caribbean Dollar',
    symbol: 'XC$',
  },
  {
    code: 'xpf',
    name: 'CFP franc',
    symbol: '₣',
  },
  {
    code: 'xof',
    name: 'CFA Franc BCEAO',
    symbol: 'CFa',
  },
  {
    code: 'yer',
    name: 'Yemeni Rial',
    symbol: 'YR',
  },
  {
    code: 'zar',
    name: 'South African Rand',
    symbol: 'R',
  },
  {
    code: 'zmw',
    name: 'Zambian Kwacha',
    symbol: 'ZK',
  },
  {
    code: 'zwl',
    name: 'Zimbabwean Dollar',
    symbol: 'ZWL$',
  },
  {
    code: 'aoa',
    name: 'Kwanza',
    symbol: 'Kz',
  },
  {
    code: 'awg',
    name: 'Aruban Florin',
    symbol: 'ƒ',
  },
  {
    code: 'bsd',
    name: 'Bahamian Dollar',
    symbol: 'B$',
  },
  {
    code: 'bbd',
    name: 'Barbados Dollar',
    symbol: 'Bds$',
  },
  {
    code: 'bmd',
    name: 'Bermudian Dollar',
    symbol: '$',
  },
  {
    code: 'btn',
    name: 'Ngultrum',
    symbol: 'Nu.',
  },
  {
    code: 'bov',
    name: 'Mvdol',
    symbol: 'BOV',
  },
  {
    code: 'kyd',
    name: 'Cayman Islands Dollar',
    symbol: '$',
  },
  {
    code: 'clf',
    name: 'Unidad de Fomento',
    symbol: 'UF',
  },
  {
    code: 'cou',
    name: 'Unidad de Valor Real',
    symbol: 'COU',
  },
  {
    code: 'cup',
    name: 'Cuban Peso',
    symbol: '$MN',
  },
  {
    code: 'cuc',
    name: 'Peso Convertible',
    symbol: 'CUC$',
  },
  {
    code: 'ang',
    name: 'Netherlands Antillean Guilder',
    symbol: 'NAƒ',
  },
  {
    code: 'svc',
    name: 'El Salvador Colon',
    symbol: 'SVC',
  },
  {
    code: 'szl',
    name: 'Lilangeni',
    symbol: 'E',
  },
  {
    code: 'fkp',
    name: 'Falkland Islands Pound',
    symbol: '£',
  },
  {
    code: 'fjd',
    name: 'Fiji Dollar',
    symbol: 'FJ$',
  },
  {
    code: 'gmd',
    name: 'Dalasi',
    symbol: 'D',
  },
  {
    code: 'gip',
    name: 'Gibraltar Pound',
    symbol: '£',
  },
  {
    code: 'gyd',
    name: 'Guyana Dollar',
    symbol: 'GY$',
  },
  {
    code: 'htg',
    name: 'Gourde',
    symbol: 'G',
  },
  {
    code: 'xdr',
    name: 'SDR (Special Drawing Right)',
    symbol: 'SDR',
  },
  {
    code: 'jod',
    name: 'Jordanian Dinar',
    symbol: 'د.ا',
  },
  {
    code: 'kpw',
    name: 'North Korean Won',
    symbol: '₩',
  },
  {
    code: 'kgs',
    name: 'Som',
    symbol: 'KGS',
  },
  {
    code: 'lak',
    name: 'Lao Kip',
    symbol: '₭N',
  },
  {
    code: 'lsl',
    name: 'Loti',
    symbol: 'L',
  },
  {
    code: 'lrd',
    name: 'Liberian Dollar',
    symbol: 'L$',
  },
  {
    code: 'mwk',
    name: 'Malawi Kwacha',
    symbol: 'Mk',
  },
  {
    code: 'mvr',
    name: 'Rufiyaa',
    symbol: 'MRf',
  },
  {
    code: 'mru',
    name: 'Ouguiya',
    symbol: 'MRU',
  },
  {
    code: 'xua',
    name: 'ADB Unit of Account',
    symbol: 'XUA',
  },
  {
    code: 'mxv',
    name: 'Mexican Unidad de Inversion (UDI)',
    symbol: 'MXV',
  },
  {
    code: 'mnt',
    name: 'Tugrik',
    symbol: '₮',
  },
  {
    code: 'pgk',
    name: 'Kina',
    symbol: 'K',
  },
  {
    code: 'shp',
    name: 'Saint Helena Pound',
    symbol: '£',
  },
  {
    code: 'wst',
    name: 'Tala',
    symbol: 'WS$',
  },
  {
    code: 'stn',
    name: 'Dobra',
    symbol: 'Db',
  },
  {
    code: 'scr',
    name: 'Seychelles Rupee',
    symbol: 'SRe',
  },
  {
    code: 'sll',
    name: 'Leone',
    symbol: 'SLL',
  },
  {
    code: 'xsu',
    name: 'Sucre',
    symbol: 'XSU',
  },
  {
    code: 'sbd',
    name: 'Solomon Islands Dollar',
    symbol: 'SI$',
  },
  {
    code: 'ssp',
    name: 'South Sudanese Pound',
    symbol: '£',
  },
  {
    code: 'srd',
    name: 'Surinam Dollar',
    symbol: 'Sr$',
  },

  {
    code: 'che',
    name: 'WIR Euro',
    symbol: 'che',
  },
  {
    code: 'chw',
    name: 'WIR Franc',
    symbol: 'chw',
  },
  {
    code: 'tjs',
    name: 'Somoni',
    symbol: 'SM',
  },
  {
    code: 'tmt',
    name: 'Turkmenistan New Manat',
    symbol: 'T',
  },
  {
    code: 'uyi',
    name: 'Uruguay Peso en Unidades Indexadas (UI)',
    symbol: 'UYI',
  },
  {
    code: 'uyw',
    name: 'Unidad Previsional',
    symbol: 'UP',
  },
  {
    code: 'vuv',
    name: 'Vatu',
    symbol: 'VT',
  },
  {
    code: 'ves',
    name: 'Bolívar Soberano',
    symbol: 'Bs',
  },
  {
    code: '',
    name: '',
    symbol: '',
  },
  {
    code: '',
    name: '',
    symbol: '',
  },
]
export default currencies
